import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
} from 'vue-router'
import { useUserStore } from '@/store/modules/user'
import { sideBarStore } from '@/store/modules/sideBar.ts'
import { useDictStore } from '@/store/modules/dict'
import { usePermissionStore } from '@/store/modules/permission'
import { isEmpty } from '@/libs/utils/data-checker'
import routes from './routes'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { constRoute } from './permissionRoute.ts'
NProgress.configure({ showSpinner: false }) // NProgress Configuration

const isFileProtocol =
  typeof window !== 'undefined' && window.location.protocol === 'file:'

const router = createRouter({
  // 采用 history 模式
  history: isFileProtocol ? createWebHashHistory() : createWebHistory('/'),
  routes: routes,
  strict: true,
  scrollBehavior: () => ({ left: 0, top: 0 }),
})

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  const userStore = useUserStore()
  const sideStore = sideBarStore()
  const dictStore = useDictStore()
  const permissionStore = usePermissionStore()
  // 需检查并且没有token跳登录页
  if (!to.meta.noCheck && !userStore.hasLogged) {
    next({ path: '/loginPage' })
    NProgress.done()
  } else {
    // 字典无缓存并且，需检查，请求字典
    if (!dictStore.getIsSetDict && !to.meta.noCheck) {
      dictStore.setDictMap()
    }

    // 需检查
    if (!to.meta.noCheck) {
      if (!isEmpty(permissionStore.getRoutes)) {
        // 有页面权限
        if (
          !permissionStore.getRoutes.some(e => e.path == to.path) &&
          !constRoute.some(e => e.path == to.path)
        ) {
          // 无匹配时操作
          next(permissionStore.getRoutes[0].path)
          NProgress.done()
          return
        }
      } else {
        // 无页面权限
        try {
          await userStore.initUserInfo()
        } catch (error) {
          next('/noPermission')
        }
        if (isEmpty(permissionStore.getRoutes)) {
          next('/noPermission')
        } else {
          if (to.path) {
            next(to)
          } else {
            next(permissionStore.getRoutes[0].path)
          }
        }
        NProgress.done()
        return
      }
    }
    if (to.meta.menuKey) {
      sideStore.setSideBar(to.meta.menuKey)
    }
    next()
    NProgress.done()
  }
})
export default router
